(() => {
  const SELECTOR = '[data-blend-staged-header]';
  const SCROLL_ENTER_THRESHOLD = 32;
  const SCROLL_EXIT_THRESHOLD = 8;

  const mountHeader = (header) => {
    if (header.dataset.blendHeaderMounted === 'true') return;

    header.dataset.blendHeaderMounted = 'true';

    let frameRequested = false;
    let isScrolled = window.scrollY > SCROLL_ENTER_THRESHOLD;
    const drawerContainer = header.querySelector('header-drawer > details');
    const drawerSummary = drawerContainer?.querySelector(':scope > summary');
    const desktopDisclosures = [
      ...header.querySelectorAll(
        '.blend-menu-region--desktop .blend-menu-region__details'
      ),
    ];
    const desktopSearch = header.querySelector('.blend-desktop-search');
    const desktopSearchInput = desktopSearch?.querySelector('input[type="search"]');

    const closeDesktopDisclosures = (exception) => {
      desktopDisclosures.forEach((disclosure) => {
        if (disclosure !== exception) disclosure.removeAttribute('open');
      });
    };

    const closeDesktopSearch = () => {
      if (typeof desktopSearch?.close === 'function') desktopSearch.close();
      desktopSearch?.removeAttribute('open');
      desktopSearchInput?.setAttribute('aria-expanded', 'false');
    };

    const updateState = () => {
      const scrollPosition = Math.max(0, window.scrollY);

      if (!isScrolled && scrollPosition > SCROLL_ENTER_THRESHOLD) {
        isScrolled = true;
      } else if (isScrolled && scrollPosition < SCROLL_EXIT_THRESHOLD) {
        isScrolled = false;
      }

      const nextState = String(isScrolled);
      if (header.dataset.scrolled !== nextState) {
        header.dataset.scrolled = nextState;
      }

      frameRequested = false;
    };

    const onScroll = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateState);
    };

    const bindDisclosure = (disclosure) => {
      const source = disclosure.querySelector(':scope > summary');
      if (!source) return;

      disclosure.addEventListener('toggle', () => {
        source.setAttribute('aria-expanded', String(disclosure.open));
        if (disclosure.open) {
          closeDesktopDisclosures(disclosure);
          closeDesktopSearch();
        }
      });

      disclosure.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!disclosure.contains(document.activeElement) && !disclosure.matches(':hover')) {
            disclosure.removeAttribute('open');
          }
        });
      });
    };

    updateState();
    window.addEventListener('scroll', onScroll, { passive: true });

    desktopDisclosures.forEach(bindDisclosure);

    if (desktopSearchInput) {
      const searchObserver = new MutationObserver(() => {
        const searchIsOpen = desktopSearchInput.getAttribute('aria-expanded') === 'true';
        if (searchIsOpen) closeDesktopDisclosures();
      });
      searchObserver.observe(desktopSearchInput, { attributes: true, attributeFilter: ['aria-expanded'] });
      desktopSearchInput.addEventListener('focus', () => closeDesktopDisclosures());
    }

    if (drawerContainer && drawerSummary) {
      drawerContainer.addEventListener('toggle', () => {
        drawerSummary.setAttribute('aria-expanded', String(drawerContainer.open));
      });

      drawerContainer.addEventListener('click', (event) => {
        if (event.target !== drawerContainer || !drawerContainer.open) return;
        drawerSummary.click();
      });
    }

  };

  const mountAllHeaders = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(mountHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountAllHeaders(), { once: true });
  } else {
    mountAllHeaders();
  }

  document.addEventListener('shopify:section:load', (event) => mountAllHeaders(event.target));
})();
